import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import api from "@/lib/api";

export default function Events() {
  const { t, lang } = useI18n();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).finally(() => setLoading(false)); }, []);

  const fmt = (d) => new Date(d).toLocaleDateString(lang, { day: "numeric", month: "long", year: "numeric" });

  return (
    <div>
      <section className="bg-th-blue th-pattern text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display font-bold text-4xl sm:text-5xl">{t("events_title")}</h1>
          <p className="mt-3 text-white/75 max-w-2xl text-lg">{t("events_subtitle")}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {loading ? <p className="text-slate-500">{t("loading")}</p> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7" data-testid="events-grid">
            {events.map((e) => (
              <Link to={`/eventos/${e.id}`} key={e.id} data-testid={`event-card-${e.id}`} className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-xl transition-all">
                <div className="h-44 overflow-hidden relative">
                  <img src={e.image_url} alt={e.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 left-3 bg-th-blue text-white rounded-lg px-3 py-1.5 text-center shadow-lg">
                    <div className="font-display font-bold text-lg leading-none">{new Date(e.date).getDate()}</div>
                    <div className="text-[10px] uppercase">{new Date(e.date).toLocaleDateString(lang, { month: "short" })}</div>
                  </div>
                </div>
                <div className="p-5">
                  <div className="text-xs text-th-gold font-semibold uppercase tracking-wide flex items-center gap-1"><Calendar className="w-3 h-3" />{fmt(e.date)}</div>
                  <h3 className="mt-2 font-display font-semibold text-xl text-th-blue leading-snug">{e.title}</h3>
                  <div className="mt-2 text-sm text-slate-500 flex items-center gap-1"><MapPin className="w-4 h-4 text-th-gold" />{e.location}</div>
                  <div className="mt-3 flex items-center justify-between">
                    <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${e.price > 0 ? "bg-th-gold/15 text-th-blue" : "bg-slate-100 text-slate-500"}`}>{e.price > 0 ? `${e.price.toFixed(2)} €` : t("ev_free")}</span>
                    <span className="flex items-center text-th-blue font-medium text-sm group-hover:text-th-gold">{t("event_register")} <ArrowRight className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
